import { Component, OnDestroy, OnInit } from '@angular/core';
import { OfbizForm, OfbizList } from '@urbannex/ofbiz-forms';
import { ActionState, BaseComponentConfig, ComponentConfig, ConfigOptions, CustomContainerItem, ProductEditContainerComponent, UpdateComponentStoreService, ViewContainersService } from '@urbannex/view-containers';
import { PROD_FORMS } from './forms';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { ConfigurationService } from '@urbannex/configuration';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, Subscription, catchError, map, takeUntil } from 'rxjs';
import { options } from './configoptions';


@Component({
  selector: 'ubs-products',
  template: `<ubs-view-containers [componentConfig]="componentConfig" [breadCrumbs]="breadCrumbs"></ubs-view-containers>`,
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent extends BaseComponentConfig implements OnInit, OnDestroy {

  products: any[] = [];

  retrievedData: Subscription;

  private readonly destroy$ = new Subject<void>()

  constructor(viewContainerService: ViewContainersService,
    menuService: NbMenuService,
    route: ActivatedRoute,
    router: Router,
    private http: HttpClient,
    updateComponentStoreService: UpdateComponentStoreService,
    configurationService: ConfigurationService) {
    super(viewContainerService, menuService, configurationService, route, router, updateComponentStoreService)
    options.defaultAction = ActionState.LIST;
    this.componentConfig = new ComponentConfig(options);
    this.retrievedData = this.viewContainerService.getNotifiedSuccess().pipe(takeUntil(this.destroy$)).subscribe(data => {
      console.log(data);
    })
    /* this.menuService.onItemClick().subscribe(menuBag =>{
      this.resolveItem(menuBag.item.data);
      updateComponentStoreService.handleMenuItemSelected(menuBag.item.data);
    }) */
  }

  ngOnInit(): void {
    console.log("Products.component")
    this.baseUrl = this.getBaseUrl();
    const menuAndTitleOptions = this.componentConfig.getMenuAndTitleOptions();
    const menuItems: NbMenuItem[] = [];
    const menuTag = menuAndTitleOptions.menuTag;


    this.viewContainerService.notifiedSuccess.subscribe(data => {
      console.log(`ProductsComponent received notifiedSuccess:`, data);
      if (data["rows"] != undefined) {
        const products: any[] = [];
        const rows: any[] = data["rows"];
        rows.forEach((row: any[]) => {
          const product: any = {};
          row.forEach(field => {
            for (let [k, v] of Object.entries(field)) {
              if (k === "productId") {
                v = field["parameterMap"]["productId"]
              }
              product[k] = v;
            }
          })
          products.push(product);
        })
        if (products.length > 0) {
          const _menuItems = this.createMenuItems(products);
          console.log(_menuItems);
        }
        this.menuService.addItems(menuItems, menuTag)
      }
    })
    /* this.getProducts(this.baseUrl).subscribe(resp => {
      let products:any[] = [];
      let message = resp["successMessage"]
        if(message == "OK"){
          let data = resp["data"];
            let formData = data["formData"];
            let rows:any[] = formData.rows;
            console.log(rows);
            rows.forEach((row:any[]) => {
              let product:any = {};
              row.forEach(field => {
                for(let[k,v] of Object.entries(field)){
                  if(k === "productId"){
                    v = field["parameterMap"]["productId"]
                  }
                  product[k] = v;
                }
              })
              products.push(product);
            })
            if(products.length > 0){
              let _menuItems = this.createMenuItems(products);
              console.log(_menuItems);
            }
            this.menuService.addItems(menuItems,menuTag)
        }
    }); */
    this.breadCrumbs = this.setBreadCrumbs(this.componentConfig);
    /* setTimeout(() => {
      if(menuAndTitleOptions != undefined){
        console.log(menuAndTitleOptions);
        let menuTag = menuAndTitleOptions.menuTag;
        console.log(menuTag);
        let menuItems:NbMenuItem[] = [
          {title:"List Products",icon:"list-outline"},
          {title:"New Product",icon:"plus-outline"},
          {title:"Recent Products",group:true,icon:"grid-outline"}
        ];
        if(this.products.length > 0){
          let _menuItems = this.createMenuItems(this.products);
          console.log(_menuItems);
          menuItems = menuItems.concat(_menuItems);
        }
        this.menuService.addItems(menuItems,menuTag)
      }else{
        console.error("No menuAndTitleOptions");
      }
    },500) */
  }



  getProducts(baseUrl: string): Observable<any> {
    const url: string = baseUrl + 'widgets/grid/value/ListProductCategoryMembers?location=component://kwikstore/widget/ProductForms.xml&productCategoryId=CATALOG1_SEARCH';
    return this.http.get<any>(url).pipe(
      catchError(this.handleError),
      map(resp => resp)) /* {
        let message = resp["successMessage"]
        if(message == "OK"){
          let data = resp["data"];
            let formData = data["formData"];
            let rows:any[] = formData.rows;
            console.log(rows);
            rows.forEach((row:any[]) => {
              let product:any = {};
              row.forEach(field => {
                for(let[k,v] of Object.entries(field)){
                  product[k] = v;
                }
              })
              this.products.push(product);
            })
        }
      })
    ) */
  }

  createMenuItems(products: any[]): NbMenuItem[] {
    const menuItems: NbMenuItem[] = [];
    products.forEach((product, i) => {
      const productId = product["productId"];
      const menuItem: NbMenuItem = { title: product["productName"] };
      if (i < 6) {
        menuItem.children = [
          {
            title: "Edit Product",
            link: "/admin/products/product/" + productId,
            icon: "edit-outline",
            data: {
              "event": "edit",
              "type": "EditProductRest",
              "label": "Edit Product " + productId,
              "data": {
                formData: {
                  formName: "EditProductRest",
                  formLocation: "component://kwikstore/widget/ProductForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Prices",
            link: "/admin/products/product/" + productId + "/prices",
            icon: "pricetags-outline",
            data: {
              "event": "relate",
              "type": "Prices",
              "label": "Edit Product Prices " + productId,
              "data": {
                formData: {
                  formName: "AddProductPriceRest",
                  formLocation: "component://kwikstore/widget/ProductForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Content",
            link: "/admin/products/product/" + productId + "/content",
            icon: "book-outline",
            data: {
              "event": "relate",
              "type": "Content",
              "label": "Edit Product Content " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Geos",
            link: "/admin/products/product/" + productId + "/geos",
            icon: "map-outline",
            data: {
              "event": "relate",
              "type": "Geos",
              "label": "Edit Store: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "IDs",
            link: "/admin/products/product/" + productId + "/ids",
            icon: "info-outline",
            data: {
              "event": "relate",
              "type": "IDs",
              "label": "Edit Product Identification: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Categories",
            link: "/admin/products/product/" + productId + "/categories",
            icon: "folder-outline",
            data: {
              "event": "relate",
              "type": "Categories",
              "label": "Edit Product Categories: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Keywords",
            link: "/admin/products/product/" + productId + "/keywords",
            icon: "text-outline",
            data: {
              "event": "relate",
              "type": "Keywords",
              "label": "Edit Product Keywords: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Associations",
            link: "/admin/products/product/" + productId + "/associations",
            icon: "link-2-outline",
            data: {
              "event": "relate",
              "type": "Associations",
              "label": "Edit Product Associations: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Costs",
            link: "/admin/products/product/" + productId + "/costs",
            icon: "options-outline",
            data: {
              "event": "relate",
              "type": "Costs",
              "label": "Edit Product Costs: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Attributes",
            link: "/admin/products/product/" + productId + "/attributes",
            icon: "options-2-outline",
            data: {
              "event": "relate",
              "type": "Attributes",
              "label": "Edit Product Attributes: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Features",
            link: "/admin/products/product/" + productId + "/features",
            icon: "checkmark-square-2-outline",
            data: {
              "event": "relate",
              "type": "Features",
              "label": "Edit Product Features: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Facilities",
            link: "/admin/products/product/" + productId + "/facilities",
            icon: "home-outline",
            data: {
              "event": "relate",
              "type": "Facilities",
              "label": "Edit Product Facilities: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Locations",
            link: "/admin/products/product/" + productId + "/locations",
            icon: "pin-outline",
            data: {
              "event": "relate",
              "type": "Locations",
              "label": "Edit Product Locations " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Inventory",
            link: "/admin/products/product/" + productId + "/inventory",
            icon: "activity-outline",
            data: {
              "event": "relate",
              "type": "Inventory",
              "label": "Edit Product Inventory: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Suppliers",
            link: "/admin/products/product/" + productId + "/suppliers",
            icon: "people-outline",
            data: {
              "event": "relate",
              "type": "Suppliers",
              "label": "Edit Product Suppliers " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Agreements",
            link: "/admin/products/product/" + productId + "/agreements",
            icon: "archive-outline",
            data: {
              "event": "relate",
              "type": "Agreements",
              "label": "Edit Product Agreements " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Accounts",
            link: "/admin/products/product/" + productId + "/accounts",
            icon: "file-text-outline",
            data: {
              "event": "relate",
              "type": "Accounts",
              "label": "Edit Product Accounts: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Payment Types",
            link: "/admin/products/product/" + productId + "/payment-types",
            icon: "credit-card-outline",
            data: {
              "event": "relate",
              "type": "Payment Types",
              "label": "Edit Store " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Maintenance",
            link: "/admin/products/product/" + productId + "/maintenance",
            icon: "calendar-outline",
            data: {
              "event": "relate",
              "type": "Maintenance",
              "label": "Edit Product Maintenance: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Meters",
            link: "/admin/products/product/" + productId + "/meters",
            icon: "pantone-outline",
            data: {
              "event": "relate",
              "type": "Meters",
              "label": "Edit Product Meters " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Subscription Resources",
            link: "/admin/products/product/" + productId + "/subscription-resources",
            icon: "layers-outline",
            data: {
              "event": "relate",
              "type": "Subscription Resources",
              "label": "Edit Product Subscription Resources: " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Quick Admin",
            link: "/admin/products/product/" + productId + "/quick-admin",
            icon: "settings-outline",
            data: {
              "event": "relate",
              "type": "Quick Admin",
              "label": "Edit Product Quick Admin " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Vendor",
            link: "/admin/products/product/" + productId + "/vendors",
            icon: "person-outline",
            data: {
              "event": "relate",
              "type": "Vendor",
              "label": "Edit Product Vendors " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          },
          {
            title: "Tasks",
            link: "/admin/products/product/" + productId + "/work-efforts",
            icon: "menu-arrow-outline",
            data: {
              "event": "relate",
              "type": "Work Efforts",
              "label": "Edit Store " + productId,
              "data": {
                formData: {
                  formName: "EditProductStore",
                  formLocation: "component://kwikstore/widget/StoreForms.xml"
                },
                appContext: "catalog",
                parameters: { productId: productId }
              },
            }
          }


        ]
        menuItems.push(menuItem);
      }

    })
    console.log(menuItems)
    return menuItems;
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


}
